import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Image from 'components/Image';
import Loading from 'components/Loading';
import { ITooltipData } from 'components/ModalTooltip/types';

EquippedItemComponent.propTypes = {
  changeable: PropTypes.bool.isRequired,
  hasUseEventId: PropTypes.bool.isRequired,
  id: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  isChanging: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  shortlist: PropTypes.bool.isRequired,
  tooltipData: PropTypes.shape({}).isRequired,
  tooltipTimeout: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
};

interface Props {
  changeable: boolean,
  hasUseEventId: boolean,
  id: number,
  image: string,
  isChanging: boolean,
  name: string,
  onClick: () => void,
  shortlist: boolean,
  tooltipData: ITooltipData,
  tooltipTimeout?: boolean | number,
}


export default function EquippedItemComponent(props: Props) {
  const {
    changeable,
    id,
    image,
    isChanging,
    name,
    onClick,
    shortlist,
    tooltipData,
    tooltipTimeout,
  } = props;

  return (
    <div
      data-quality-id={id}
      className={classnames(
        shortlist && 'icon',
        changeable && shortlist && 'icon--inventory',
        !changeable && 'icon--non-interactive',
        shortlist && 'icon--emphasize',
      )}
      style={{
        marginLeft: 'auto',
        marginRight: 'auto',
        position: 'relative',
        width: changeable ? '40px' : undefined,
        height: changeable ? '40px' : undefined,
      }}
    >
      <Image
        key={image}
        type="small-icon"
        icon={image}
        alt={name}
        onClick={onClick}
        width={changeable ? 40 : undefined}
        height={changeable ? 40 : undefined}
        tooltipData={tooltipData}
        tooltipPos="bottom"
        tooltipTimeout={tooltipTimeout}
        className={classnames(
          'equipped-group__equipped',
          isChanging && 'equipped-group__equipped--is-changing',
        )}
      />
      {isChanging && (
        <div
          style={{
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
            left: 0,
            position: 'absolute',
            top: 0,
            width: '100%',
          }}
        >
          <Loading spinner small margins={false} />
        </div>
      )}
    </div>
  );
}